import React from 'react';
import PropTypes from 'prop-types';

// Component to render an individual recent favorite item
const RecentFavoritesListItem = ({ favorite }) => {
  const favoriteData = {
    title: favorite?.attributes?.title || favorite.title || favorite.name ||  'Untitled Favorite',
    category: favorite?.category || '', // Using type as category
  };

  return (
    <div className="flex flex-col p-4 border-b border-gray-100 last:border-b-0">
      <p className="font-medium text-sm leading-4.5 text-gray-900">{favoriteData.title}</p>
      <span className="px-2 py-1 text-xs font-medium mt-3 rounded-[27px] bg-gold-50 text-gold-500 inline-block w-max">
        {favoriteData.category}
      </span>
    </div>
  );
};

// PropTypes for validation
RecentFavoritesListItem.propTypes = {
    favorite: PropTypes.shape({
        type: PropTypes.string.isRequired,
        attributes: PropTypes.shape({
            title: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
};

export default RecentFavoritesListItem;
